import {
  Grid,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";

import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import Videoplayer from "../../../../components/Videoplayer";
import InfoIcon from "@mui/icons-material/Info";
import { useApp } from "../../../../hooks/useApp";
import FeatureCard from "./FeatureCard";

export default function StepTwo({ asset, setAsset }) {
  function handleChange(event) {
    const newAsset = { ...asset, [event.target.id]: event.target.value };
    setAsset(newAsset);
  }

  const { activeVideo } = useApp();

  return (
    <Grid container sx={{ flexDirection: "row", gap: 4 }}>
      {activeVideo && <Videoplayer />}
      <Grid
        item
        xs={12}
        sm={5}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <FeatureCard asset={asset} />
      </Grid>
      <Grid item xs>
        <Stack direction={"column"} gap={4}>
          <TextField
            id="desc"
            label="Description"
            fullWidth
            value={asset.desc}
            onChange={(event) => {
              handleChange(event);
            }}
          />

          <TextField
            id="editorUrl"
            label="Open the Editor"
            fullWidth
            value={asset.editorUrl}
            onChange={(event) => {
              handleChange(event);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LaptopMacIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            id="video"
            label="Play Video"
            fullWidth
            value={asset.video}
            onChange={(event) => {
              handleChange(event);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <InfoIcon />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
